import React from 'react';
import Dance from './Dance';

import {Link} from 'react-router';

import {getDances} from './AppUtils';

class Browse extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mounted: false,
            dances: null
        };

        this.onVideoPlay = this.onVideoPlay.bind(this);
        this.setDances = this.setDances.bind(this);
    }

    componentDidMount() {
        this.setDances(this.props.location.pathname);
    }

    componentWillReceiveProps(nextProps) {
        this.setDances(nextProps.location.pathname);
    }

    setDances(path) {
        this.setState({dances: null});
        var completed = false;
        if (path == "/watch/completed") {
            completed = true;
        }
        getDances(completed)
            .then((success) => {
                //console.log(success);
                this.setState({mounted: true, dances: success});
            });
    }

    onVideoPlay(ref) {

    }

    render() {
        const {dances} = this.state;
        if (dances) {
            var posts = dances.map(function (object, i) {
                if (object.dances.length === 5 && window.location.pathname !== '/watch/completed') return null
                return <Dance key={"dance" + i} play={false} dance={object} browse={true} respond={true}/>;
            });

            return (
                <div className="browse">
                    <h1>"The Body Never Lies"</h1>
                    <h2>- Martha Graham</h2>

                    <div className="browse-nav">
                        <Link to="/watch" activeClassName="browse-on">In Progress</Link>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Link to="/record" className="record-btn" activeClassName="browse-on">Start A New Dance</Link>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Link to="/watch/completed" activeClassName="browse-on">Completed</Link>

                    </div>
                    {posts}
                </div>
            );

        } else {
            return (
                <div className="browse">
                    <h1>Loading...</h1>
                </div>
            )
        }
    }
}

export default Browse;



// WEBPACK FOOTER //
// src/Browse.js